module.exports = __webpack_public_path__ + "8b5a6266ced86bd7d12d6053233097af.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/client/new-session-diamond-pattern.png
// module id = 794
// module chunks = 0